import { render, staticRenderFns } from "./Tarefas.vue?vue&type=template&id=3d7d452b"
import script from "./Tarefas.vue?vue&type=script&lang=js"
export * from "./Tarefas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports